import React, { useRef, useState } from 'react';
import {BottomSheet} from "react-spring-bottom-sheet";
import 'react-spring-bottom-sheet/dist/style.css'
import {Button} from "react-bootstrap";

const BottomModal = (props) => {
  const dummyRef = useRef(null);
  const contentRef = useRef(null);
  const [canDrag, setCanDrag] = useState(true);

  function blocked(e) {
    const target = e.target;
    const isTimeInput = target.closest('.order-time') || target.closest('.regular-time');
    const isPickerPopup = target.closest('.MuiPickersPopper-root') || target.closest('.MuiClock-root') || target.closest('.MuiPickerStaticWrapper-root');
    const isMap = target.closest('.leaflet-container');
    return (isTimeInput || isPickerPopup || isMap);
  }

  const handleScroll = () => {
    if (!contentRef.current) return;
    const scrollTop = contentRef.current.scrollTop;
    setCanDrag(scrollTop === 0);
  };

  return (
    <BottomSheet
      className={props.className}
      style={props.style}
      open={props.open}
      initialFocusRef={dummyRef}
      onDismiss={props.onDismiss}
      expandOnContentDrag={canDrag}
      snapPoints={({ maxHeight, minHeight }) => [minHeight + 35, props.fullHeight ? maxHeight * 0.98 : maxHeight * 0.8]}
      header={
        <div className='d-flex justify-content-between align-items-start'>
          {props.header}
          <Button className='btn-close' onClick={props.onDismiss}><b>×</b></Button>
        </div>
      }
      footer={props.footer}
      onSpringStart={(event) => {
        if (event.type === 'OPEN') {
          window.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'BOTTOM_SHEET', open: true }));
          props.onStart?.();
        }
      }}
      onSpringEnd={(event) => {
        if (event.type === 'CLOSE') {
          window.ReactNativeWebView?.postMessage(JSON.stringify({ type: 'BOTTOM_SHEET', open: false }));
        }
        if (event.type === 'OPEN') props.onEnd?.();
      }}
    >
      <div
        className="px-3"
        ref={contentRef}
        onScroll={handleScroll}
        onPointerDown={(e) => {
          if (blocked(e)) e.stopPropagation();
        }}
        onTouchStart={(e) => {
          if (blocked(e)) e.stopPropagation();
        }}
        onMouseDown={(e) => {
          if (blocked(e)) e.stopPropagation();
        }}
      >
        {props.children}
      </div>
    </BottomSheet>
  );
};

export default BottomModal;